const lemonx = '/lemonxweb-v1/invoke-v3/'
const appUrl = '/wikifxweb-v1/invoke-v3/'
const xiaochengxu = '/wikifxapp-v1/invoke-v3/'
const v4BaseMap = {
  wikibit: 'https://api-gw.interface004.com',
  gateway: 'https://api-gw.interface003.com'
}

let url = window.isx ? lemonx : appUrl
if (window?.location?.href?.includes('GoldenEye')) {
  url = xiaochengxu
}
// const appUrl = "/wikifxapp-v1/invoke-v3/";
import request from '@/utils/request'
// const url = '/wikifxweb-v1/invoke-v3/{customKey}';

export function v3(data, headers) {
  try {
    const o = Object.values(headers)
    const v = o[0].split('$')[0]
    return request({
      url: url + v,
      method: 'post',
      data,
      headers
    })
  } catch (err) {
    console.log('v3接口异常,data:' + JSON.parse(data) + 'header:' + JSON.parse(headers))
  }
}

export function v4(apiUrl, config = {}) {
  try {
    const {
      baseKey = 'gateway',
      method = 'get',
      params,
      data,
      headers = {}
    } = config
    const baseURL = v4BaseMap[baseKey] || baseKey || v4BaseMap.gateway
    return request({
      url: `${baseURL}${apiUrl}`,
      method,
      params,
      data,
      headers
    })
  } catch (err) {
    console.log('v4接口异常,url:' + apiUrl, err)
  }
}
